module.exports = __webpack_public_path__ + "img/MX-B048045A-BS.fa3426c0.png";